export const FAVOURITE_LARGE_SIZE = 44;
export const FAVOURITE_LARGE_PRESS_SIZE = FAVOURITE_LARGE_SIZE - 4;
export const FAVOURITE_SMALL_SIZE = 32;
export const FAVOURITE_SMALL_PRESS_SIZE = FAVOURITE_SMALL_SIZE - 4;
